{
  "nl": {
    "task_assignment": {
      "actions": {
        "confirm": "Markeer als klaar",
        "create": "Taak",
        "reopen": "Heropenen",
        "update": "Taak bewerken"
      },
      "assignee_types": {
        "customer": "Klant",
        "employee": "Medewerker",
        "partner": "Partner"
      },
      "attributes": {
        "assignee": "Toegewezen aan",
        "assignees": "Toegewezen aan",
        "created_at": "Aangemaakt",
        "due_date": "Vervaldatum",
        "project": "Project",
        "published": "Gepubliceerd",
        "status": "Status",
        "task": "Taak",
        "unit": "Eenheid"
      },
      "labels": {
        "add_assignee": "Toegewezen aan toevoegen…",
        "add_customers": "Klanten toevoegen",
        "already_assigned": "Deze taak is al toegevoegd aan deze eenheid.",
        "completed": "Voltooid",
        "confirm_message": "Weet je zeker dat je deze taak als voltooid wilt markeren?",
        "customers": "Klanten",
        "my_tasks": "Mijn taken",
        "no_assignees": "Nog geen toegewezen aan.",
        "no_assignments": "Nog geen taken.",
        "no_assignments_task": "Nog geen toewijzingen voor deze taak.",
        "no_assignments_unit": "Nog geen taken voor deze eenheid.",
        "publish_all": "Alles publiceren",
        "publish_customers": "Publiceren voor de klanten van elke eenheid",
        "published": "Gepubliceerd",
        "required": "Dit veld is verplicht",
        "select_task": "Selecteer een taak",
        "upload_hint": "Upload het gevraagde document of de gevraagde documenten om deze taak te voltooien.",
        "uploaded_documents": "Geüploade documenten"
      },
      "statuses": {
        "completed": "Voltooid",
        "draft": "Concept",
        "pending": "In behandeling"
      },
      "toasts": {
        "completed": "Taak voltooid",
        "create": "Taak aangemaakt",
        "delete": "Taak verwijderd",
        "uncompleted": "Taak heropend",
        "update": "Taak bijgewerkt"
      }
    }
  }
}
